import React from 'react';

import './styles.scss';

export default function EmbedFooter({ url, hostname }) {
  return (
    <footer class="embed-footer">
      <div className="embed-footer__site">
        <a href={url} target="_blank">
          {hostname || window.location.hostname}
        </a>
      </div>
      <ul className="embed-footer__items">
        <li className="embed-footer__item">
          <a href="https://chathamhouse.org" target="_blank">
            © Chatham House
          </a>
        </li>
        <li className="embed-footer__item">
          <a href="http://appliedworks.co.uk" target="_blank">
            Map by Applied Works
          </a>
        </li>
      </ul>
    </footer>
  );
}
